var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.dashboardJson)?_c('div',[_c('el-button',{attrs:{"size":"small","icon":"el-icon-plus"},on:{"click":_vm.createDash}},[_vm._v("创建视图")])],1):_c('DataViewDashboardComponent',{attrs:{"dashJson":_vm.dashboardJson},on:{"save":_vm.saveDash}})
}
var staticRenderFns = []

export { render, staticRenderFns }